import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import { Form } from '@ant-design/compatible';
import { findIndex, isNil, sortBy } from 'lodash';
import RecommendProductSaveWrap from '../../../views/recommend/product/save/RecommendProductSaveWrap';
import { appActions } from '../../../store/modules/app';
import { recommendProductActions } from '../../../store/modules/recommend/product';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../../constants/service/common/utilConstants';
import {
  MINIMUM_NUMBER_OF_RECOMMEND_PRODUCT_ITEM_COUNT,
  MAXIMUM_NUMBER_OF_RECOMMEND_PRODUCT_ITEM_COUNT,
  RECOMMEND_PRODUCT_TYPE,
} from '../../../constants/service/app/recommendProductConstants';
import { asyncSimpleModal } from '../../../lib/common';

class RecommendProductSaveContainer extends Component {
  onChangeAttachment = (e) => {
    e.preventDefault();
    let files;
    if (e.target) {
      files = e.target.files;
    }

    if (!files[0]) return false;

    this.props.setData({
      path: ['recommendProductSave', 'recommendProductInfo', 'attachment'],
      value: [files[0]],
    });

    e.target.value = null;
  };

  /**
   *  추천 상품 복사하기
   */
  onSubmit = () => {
    const { form, recommendProductSave, createRecommendProduct, createRecommendProductByExcel } = this.props;
    const { recommendProductInfo, recommendProductItemList } = recommendProductSave;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 150, offsetTop: 150 } }, async (err) => {
      if (err) return;

      /**
       *  추천 타입 선택 여부 체크
       */
      if (isNil(recommendProductInfo.type)) {
        message.error('추천 타입을 선택해주세요.');
        return;
      }

      const maximumNumberOfRecommendProductItemCount =
        MAXIMUM_NUMBER_OF_RECOMMEND_PRODUCT_ITEM_COUNT[recommendProductInfo.type];
      const minimumNumberOfRecommendProductItemCount =
        MINIMUM_NUMBER_OF_RECOMMEND_PRODUCT_ITEM_COUNT[recommendProductInfo.type];

      if (recommendProductInfo.attachment.length > 0) {
        /**
         * 다이렉트 업로드
         */
        createRecommendProductByExcel({
          /**
           *  추천 상품 정보
           */
          recommendProductInfo: {
            /**
             *  추천 상품 타입
             */
            type: recommendProductInfo.type,
            /**
             *  메모
             */
            memo: recommendProductInfo.memo,
          },
          attachment: recommendProductInfo.attachment,
        });
      } else {
        /**
         *  추천 상품 아이템 최소 개수 체크
         */
        if (
          minimumNumberOfRecommendProductItemCount &&
          recommendProductItemList.selectedItemList.list.length < minimumNumberOfRecommendProductItemCount
        ) {
          message.error(`추천 상품 아이템은 최소 ${minimumNumberOfRecommendProductItemCount}개이상입니다.`);
          return;
        } else if (
          /**
           *  추천 상품 타입이 인기 검색어인 경우에는
           *  아이템 개수가 무조건 10개로 설정이되어야 함.
           */
          recommendProductInfo.type === RECOMMEND_PRODUCT_TYPE.POPULAR_POP &&
          recommendProductItemList.selectedItemList.list.length !== maximumNumberOfRecommendProductItemCount
        ) {
          message.error(`인기 검색어는 ${maximumNumberOfRecommendProductItemCount}개로 설정해야합니다..`);
          return;
        }

        createRecommendProduct({
          /**
           *  추천 상품 정보
           */
          recommendProductInfo: {
            /**
             *  추천 상품 타입
             */
            type: recommendProductInfo.type,
            /**
             *  메모
             */
            memo: recommendProductInfo.memo,
          },
          /**
           *  추천 상품에 연결된 상품 id 리스트
           */
          recommendProductItemIdList: recommendProductItemList.selectedItemList.idList,
        });
      }
    });
  };

  /**
   *  추천 상품에 연결할 아이템 리스트 불러오기
   */
  getRecommendProductItemList = (option) => {
    const { getRecommendProductItemList, recommendProductSave } = this.props;
    const { recommendProductItemList } = recommendProductSave;
    const { filterOption, sortOption, pagination } = recommendProductItemList.itemList;

    getRecommendProductItemList({
      filterOption,
      sortOption,
      pagination,
      ...option,
    });
  };

  /**
   *  추천 상품에 연결할 아이템 선택하기
   */
  selectRecommendProductItemList = async (action, moveIdList) => {
    const { setData, recommendProductSave } = this.props;
    const { recommendProductInfo, recommendProductItemList } = recommendProductSave;
    const { itemList, selectedItemList } = recommendProductItemList;

    /**
     *  업데이트 될 선택된 연결할 아이템 리스트
     */
    let updatedSelectRecommendProductItemList = [];

    /**
     *  연결할 아이템 아이템 추가
     */
    if (action === 'add') {
      let targetList = itemList.list.filter((item) => moveIdList.includes(item.id));

      /**
       *  이전에 선택되어 있던 아이템 리스트와
       *  추가로 선택된 아이템을 합침
       */
      updatedSelectRecommendProductItemList = [...targetList, ...selectedItemList.list];

      /**
       *  추가하려고 하는 아이템 개수가 초과되었을 경우
       */
      if (
        updatedSelectRecommendProductItemList.length >
        MAXIMUM_NUMBER_OF_RECOMMEND_PRODUCT_ITEM_COUNT[recommendProductInfo.type]
      ) {
        await asyncSimpleModal({
          type: 'error',
          title: '아이템 개수 초과',
          message: `추천 상품 아이템 개수는 최대 ${
            MAXIMUM_NUMBER_OF_RECOMMEND_PRODUCT_ITEM_COUNT[recommendProductInfo.type]
          } 입니다.`,
        });
        return;
      }
    } else if (action === 'remove') {
      /**
       *  연결할 아이템 아이템 해제
       */
      /**
       *  이전에 선택되어 있던 아이템 리스트에서
       *  해제한 아이템을 빼버림
       */
      updatedSelectRecommendProductItemList = selectedItemList.list.filter((item) => !moveIdList.includes(item.id));
    }

    /**
     *  선택되어진 선택된 아이템은
     *  선택할 수 없도록 함
     */
    const updatedRecommendProductItemList = itemList.list.map((item) => ({
      ...item,
      uncheckable: moveIdList.includes(item.id) ? action === 'add' : item.uncheckable,
    }));
    setData({
      path: ['recommendProductSave', 'recommendProductItemList', 'itemList', 'list'],
      value: updatedRecommendProductItemList,
    });

    /**
     *  선택된 아이템 업데이트하기
     */
    setData({
      path: ['recommendProductSave', 'recommendProductItemList', 'selectedItemList'],
      value: {
        list: updatedSelectRecommendProductItemList,
        idList: updatedSelectRecommendProductItemList.map((item) => item.id),
      },
    });
  };

  /**
   *  추천 상품 리스트 아이템 순서 변경하기
   */
  onDragEndSelectRecommendProductItemList = async (newList) => {
    const { setData, recommendProductSave } = this.props;
    const { recommendProductItemList } = recommendProductSave;
    const { selectedItemList } = recommendProductItemList;

    const updatedSelectRecommendProductItemList = sortBy(selectedItemList.list, (item) =>
      findIndex(newList, (_item) => _item.id === item.id),
    );

    await setData({
      path: ['recommendProductSave', 'recommendProductItemList', 'selectedItemList'],
      value: {
        list: updatedSelectRecommendProductItemList,
        idList: updatedSelectRecommendProductItemList.map((item) => item.id),
      },
    });
  };

  /**
   *  전체 상품 리스트 EXCEL 다운로드
   */
  getRecommendProductItemListExcelDownload = () => {
    const { getRecommendProductItemListExcelDownload, recommendProductSave, adminInfo } = this.props;
    const { recommendProductItemList } = recommendProductSave;
    const { filterOption, sortOption } = recommendProductItemList.itemList;

    getRecommendProductItemListExcelDownload({
      email: adminInfo.email,
      filterOption,
      sortOption,
    });
  };

  /**
   *  선택된 상품 리스트 EXCEL 다운로드
   */
  getSelectedRecommendProductItemListExcelDownload = () => {
    const { getSelectedRecommendProductItemListExcelDownload, recommendProductSave, adminInfo } = this.props;
    const { recommendProductItemList } = recommendProductSave;
    const { idList } = recommendProductItemList.selectedItemList;

    if (!idList.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getSelectedRecommendProductItemListExcelDownload({
      email: adminInfo.email,
      selectedRecommendProductItemIdList: idList,
    });
  };

  /**
   *  상품 리스트 EXCEL 업로드
   */
  setRecommendProductItemListExcelUpload = (file) => {
    const { setRecommendProductItemListExcelUpload, recommendProductSave } = this.props;
    const { recommendProductInfo } = recommendProductSave;

    setRecommendProductItemListExcelUpload({
      attachment: [file],
      recommendProductType: recommendProductInfo.type,
    });
  };

  render() {
    const {
      form,
      recommendProductSave,
      setData,
      mainProductCategorySelectList,
      subProductCategorySelectList,
      typeDisabled,
      getProductSubCategoryList,
    } = this.props;

    return (
      <RecommendProductSaveWrap
        form={form}
        setData={setData}
        recommendProductSave={recommendProductSave}
        mainProductCategorySelectList={mainProductCategorySelectList}
        subProductCategorySelectList={subProductCategorySelectList}
        typeDisabled={typeDisabled}
        getProductSubCategoryList={getProductSubCategoryList}
        getRecommendProductItemList={this.getRecommendProductItemList}
        selectRecommendProductItemList={this.selectRecommendProductItemList}
        onSubmit={this.onSubmit}
        onDragEndSelectRecommendProductItemList={this.onDragEndSelectRecommendProductItemList}
        getRecommendProductItemListExcelDownload={this.getRecommendProductItemListExcelDownload}
        getSelectedRecommendProductItemListExcelDownload={this.getSelectedRecommendProductItemListExcelDownload}
        setRecommendProductItemListExcelUpload={this.setRecommendProductItemListExcelUpload}
        onChangeAttachment={this.onChangeAttachment}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminInfo: state.app.adminInfo,
    recommendProductSave: state.recommendProduct.recommendProductSave,
    mainProductCategorySelectList: state.recommendProduct.mainProductCategorySelectList,
    subProductCategorySelectList: state.recommendProduct.subProductCategorySelectList,
  };
};

const mapDispatchToProps = {
  setData: recommendProductActions.setData,
  getRecommendProductItemList: recommendProductActions.getRecommendProductItemList,
  createRecommendProduct: recommendProductActions.createRecommendProduct,
  createRecommendProductByExcel: recommendProductActions.createRecommendProductByExcel,
  getRecommendProductItemListExcelDownload: recommendProductActions.getRecommendProductItemListExcelDownload,
  getSelectedRecommendProductItemListExcelDownload:
    recommendProductActions.getSelectedRecommendProductItemListExcelDownload,
  setRecommendProductItemListExcelUpload: recommendProductActions.setRecommendProductItemListExcelUpload,
  getProductSubCategoryList: appActions.getProductSubCategoryList,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(RecommendProductSaveContainer));
